import { FormulaTask, IFormulaTaskProvider } from './formula-batch-processor'

export class FormulaModel implements IFormulaTaskProvider {
  // TODO(VD-3522): in Stage 2 (formula model), implement this
  getFormulaTasks(): FormulaTask[] {
    return []
  }
}
